import React from 'react';

import { Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { LoanFeesTestIds } from '../../../../../../LoanFees.testIds';

import { buttonsContainerStyles, containerStyles } from './SubProviderConfirmDialog.styles';

const SubProviderConfirmDialog = ({
  newProviderName,
  originalProviderName,
  onConfirm,
  onDecline,
}) => (
  <div style={containerStyles}>
    <Typography variant="regular14">
      Changing the provider to <strong>{newProviderName}</strong> would move this fee from Section B
      to Section C.
    </Typography>
    <Typography variant="regular14">
      Is <strong>{newProviderName}</strong> acting as a sub-provider of{' '}
      <strong>{originalProviderName}</strong>?
    </Typography>
    <div style={buttonsContainerStyles}>
      <Button
        data-testid={LoanFeesTestIds.SUB_PROVIDER_DECLINE_BUTTON}
        variant="outlined"
        onClick={onDecline}
      >
        No
      </Button>
      <Button
        data-testid={LoanFeesTestIds.SUB_PROVIDER_CONFIRM_BUTTON}
        variant="contained"
        onClick={onConfirm}
      >
        Yes, Sub-Provider
      </Button>
    </div>
  </div>
);

SubProviderConfirmDialog.propTypes = {
  newProviderName: PropTypes.string.isRequired,
  originalProviderName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
};

export default SubProviderConfirmDialog;
